<mat-form-field class="form-element" appearance="fill">
  <mat-label> type </mat-label>
  <mat-select (selectionChange)="typeChangeAction($event)" [formControl]="selectListControl">
    @for (type of types; track type) {
      <mat-option [value]="type">{{ type }}</mat-option>
    }
  </mat-select>
</mat-form-field>